import {
  Component,
  Prop,
  Vue,
  Inject,
  toNative,
  mixins
} from "vue-facing-decorator";
import { PropOptions } from "vue";

export interface Field extends PageElement, Valued {
  mandatory?: boolean;
  readonly?: boolean;
}

export interface Valued {
  value?: string | number | boolean;
}

export interface Labeled {
  label?: string;
}

export interface PageElement extends Labeled {
  hint?: string;
  id: number | string;
}

export interface Roled {
  role?: string;
}

export function defaultResolveTxt(key: string, def: string): string {
  if (def) {
    return def;
  }
  return key;
}

@Component
class ServicedMixin extends Vue {
  @Inject({
    default: defaultResolveTxt,
    from: "resolveTxt"
  })
  readonly resolveTxt!: Function;
}

// class PageElementMixin extends mixins(ServicedMixin) implements PageElement {
// class PageElementMixin extends Vue {
@Component
class PageElementMixin extends mixins(ServicedMixin) implements PageElement {
  @Prop({
    default: null,
    type: String,
    description: "Component label"
  } as PropOptions<any>)
  readonly label?: string;

  @Prop({
    default: null,
    type: String,
    description: "Component hint"
  } as PropOptions<any>)
  readonly hint?: string;

  @Prop({
    default: null,
    type: [String, Number],
    description: "Component Id"
  } as PropOptions<any>)
  readonly id!: number | string;
}

export default toNative(PageElementMixin);
